function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__a",
  d: "M34.758.496C21.845 2.436 9.705 3.165 3.688 9.225c-6.016 6.06-2.055 19.34 1.315 20.064 2.225.479-.049-3.915 3.527-6.939-.33 4.494 5.362 9.216 7.643 9.514 2.282.298-2.696-5.618 1.008-8.57 1.895 4.322 6.701 5.307 7.418 4.146.499-.808-3.958-4.271-.803-7.453 4.383 1.195 23.816 4.531 28.222-4.897.717-1.535 1.053-3.004 1.061-4.38v-.109C53.041 4.475 46.503.223 38.367.223c-1.175 0-2.382.088-3.609.273"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__d",
  d: "M.132 0h107.184v61.411H.132z"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__f",
  d: "M105.802.002l-.01.001-.05.002-.003.001c-.284.025-.543.13-.753.293-8.435 6.281-15.257 7.543-19.772 8.38-2.232.413-3.995.739-5.346 1.512l-.015.009a9.244 9.244 0 00-2.972 2.792c-4.897-5.398-12.315-7.88-22.093-7.381l-1.985.101c-9.777.501-16.904 3.724-21.226 9.594a9.227 9.227 0 00-3.24-2.476l-.014-.007c-1.422-.632-3.21-.776-5.471-.96-4.576-.372-11.493-.934-20.528-6.326a1.444 1.444 0 00-1.732.186A1.447 1.447 0 00.29 7.438c.263.517 1.305 2.868 1.6 3.522 1.271 2.855 5.737 8.747 6.938 15.981.123.698.29 1.505.5 2.318l4.237.409-3.195 2.69a17.632 17.632 0 005.315 7.389l4.768-2.727-1.594 4.521c2.23.848 5.21 1.097 8.472.511-.372 2.092-.441 3.758-.211 5.054.589 3.358 2.474 5.064 3.842 6.055 2.854 2.07 7.274 3.421 13.513 4.131a3.977 3.977 0 012.638 2.072c.616 1.579 3.621 2.218 9.404 2.009l.021-.001.233-.012.016-.002c3.346-.208 5.795-.631 7.278-1.255 1.25-.527 1.718-1.17 1.871-1.686a3.981 3.981 0 012.42-2.344c6.449-1.412 10.844-3.32 13.431-5.835 2.523-2.451 2.807-5 2.801-6.703 0-.045-.003-.09-.006-.135a31.616 31.616 0 00-.711-4.246c1.116.092 2.241.091 3.359-.009l-.799-4.297 3.167 3.675.182-2.544 1.984 1.926c2.457-1.219 4.474-3.108 5.786-5.421l-5.092-3.901 6.426 1.143a19.724 19.724 0 001.562-5.889l-2.902-1.26s3.156-.625 3.155-.641l-4.218-1.783 4.371-.181c.999-6.388 4.214-11.707 5.099-14.344.218-.648 1.03-3.053 1.248-3.608A1.447 1.447 0 00105.87 0l-.068.002"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__i",
  d: "M11.855 11.793c-5.546 2.647-9.914 5.223-10.762 9.269-.866 4.141.876 9.544 2.298 14.354.171.537.323 1.08.463 1.624 1.482.1 2.456.188 3.376.105l-.799-4.297 3.167 3.675.182-2.544 1.984 1.926c2.457-1.219 4.474-3.108 5.786-5.421l-5.092-3.901 6.426 1.143a19.724 19.724 0 001.562-5.889l-2.902-1.26s3.156-.625 3.155-.641l-4.218-1.783 4.371-.181c.999-6.388 4.214-11.707 5.099-14.344.218-.648 1.03-3.053 1.248-3.608-4.105 6.525-9.764 9.111-15.344 11.773"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__l",
  d: "M.612 1.165c-.76.575-.109 1.439 1.661 1.695a4.825 4.825 0 003.701-.895c.43-.44-.165-1.037-1.016-1.113 0 0-.816-.059-1.752-.059-1.027 0-2.199.071-2.594.372"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__o",
  d: "M.468 1.921c-.208.767 1.682 1.298 2.873.997 1.191-.3 2.188-2.37.169-2.366h-.007C2.458.552.675 1.158.468 1.921"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__r",
  d: "M5.055.133C3.598.349.325 1.758.36 2.448c.035.69 2.385 1.777 4.879 1.29 2.494-.487 3.504-.892 3.307-1.709-.141-.606-1.77-1.923-3.16-1.923-.112 0-.223.009-.331.027"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__u",
  d: "M1.89 3.96c1.271 2.855 5.737 8.747 6.938 15.981.123.698.29 1.505.5 2.318l4.237.409-3.195 2.69a17.632 17.632 0 005.315 7.389l4.768-2.727-1.594 4.521c2.072.789 4.273 1.212 8.49.504.105-.554.222-1.094.343-1.599 1.089-4.62 2.607-10.947.773-14.667-1.011-2.052-2.15-5.032-8.86-7.127l-.115-.037c-1.216-.364-4.485-1.045-7.994-2.852C4.443 5.131.29.438.29.438c.263.517 1.305 2.868 1.6 3.522"
}), /*#__PURE__*/React.createElement("path", {
  id: "grade-mascot_svg__x",
  d: "M34.06 4.356c-.507.022-1.046.027-1.624.013-4.568-.095-6.577-.65-11.515-.435-4.938.217-6.892.959-11.426 1.44-.581.083-1.12.107-1.62.128-4.219.186-5.827-1.01-6.12-3.286-3.327 2.98 1.291 6.854 4.77 8.411 3.48 1.558 7.887 2.245 14.109 2.154l1.359-.06c6.206-.471 10.536-1.523 13.873-3.379v-.013c3.267-1.813 7.584-6.091 3.997-8.782-.088 2.273-1.582 3.624-5.803 3.809"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__b",
  x1: "194.78%",
  x2: "1.315%",
  y1: "30.605%",
  y2: "55.518%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__g",
  x1: "51.291%",
  x2: "50.037%",
  y1: "66.953%",
  y2: "36.683%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__j",
  x1: "23.342%",
  x2: "82.414%",
  y1: "61.686%",
  y2: "40.515%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__m",
  x1: "-244.104%",
  x2: "191.156%",
  y1: "56.825%",
  y2: "46.553%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__p",
  x1: "-263.754%",
  x2: "337.093%",
  y1: "62.179%",
  y2: "39.705%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__s",
  x1: "-39.335%",
  x2: "269.122%",
  y1: "52.729%",
  y2: "43.66%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__v",
  x1: "85.486%",
  x2: "16.045%",
  y1: "96.009%",
  y2: "2.428%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grade-mascot_svg__y",
  x1: "8.887%",
  x2: "111.96%",
  y1: "42.397%",
  y2: "57.402%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-28 136.292 -78.362)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__b)",
  d: "M34.758.496C21.845 2.436 9.705 3.165 3.688 9.225c-6.016 6.06-2.055 19.34 1.315 20.064 2.225.479-.049-3.915 3.527-6.939-.33 4.494 5.362 9.216 7.643 9.514 2.282.298-2.696-5.618 1.008-8.57 1.895 4.322 6.701 5.307 7.418 4.146.499-.808-3.958-4.271-.803-7.453 4.383 1.195 23.816 4.531 28.222-4.897.717-1.535 1.053-3.004 1.061-4.38v-.109C53.041 4.475 46.503.223 38.367.223c-1.175 0-2.382.088-3.609.273",
  mask: "url(#grade-mascot_svg__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(2 96.114 17.261)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#221F34",
  d: "M105.802.001l-.01.001a7.401 7.401 0 01-.051.003l-.002.001c-.284.024-.542.13-.753.293-8.435 6.28-15.257 7.543-19.773 8.38-2.231.413-3.994.74-5.346 1.511l-.014.01a9.247 9.247 0 00-2.972 2.792c-4.896-5.398-12.315-7.88-22.093-7.38l-1.985.1c-9.777.5-16.904 3.724-21.226 9.594a9.227 9.227 0 00-3.24-2.476l-.015-.007c-1.421-.632-3.208-.776-5.47-.96-4.576-.372-11.493-.934-20.529-6.327a1.44 1.44 0 00-.815-.202A1.447 1.447 0 00.29 7.438c.263.517 1.305 2.868 1.6 3.522 1.271 2.854 5.737 8.747 6.937 15.981.124.698.29 1.505.501 2.318l4.238.41-3.197 2.688a17.64 17.64 0 005.316 7.39l4.768-2.726-1.593 4.52c2.228.848 5.21 1.097 8.471.511-.372 2.092-.441 3.758-.211 5.053.589 3.36 2.474 5.065 3.841 6.056 2.856 2.07 7.276 3.421 13.514 4.131a3.983 3.983 0 012.638 2.071c.616 1.58 3.622 2.22 9.404 2.01l.02-.002.234-.012h.016c3.346-.209 5.795-.63 7.279-1.256 1.25-.527 1.717-1.17 1.871-1.686a3.984 3.984 0 012.419-2.345c6.449-1.41 10.843-3.319 13.431-5.835 2.523-2.45 2.807-4.999 2.801-6.703 0-.045-.003-.09-.007-.135a31.353 31.353 0 00-.711-4.246c1.117.093 2.242.092 3.361-.008l-.8-4.297 3.167 3.675.183-2.544 1.983 1.926c2.457-1.219 4.474-3.109 5.786-5.42l-5.093-3.902 6.427 1.143a19.702 19.702 0 001.562-5.889l-2.903-1.26s3.156-.626 3.155-.64l-4.217-1.785 4.371-.18c.999-6.389 4.214-11.707 5.099-14.344.218-.648 1.03-3.054 1.247-3.608a1.448 1.448 0 00-1.396-2.019",
  mask: "url(#grade-mascot_svg__e)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__g)",
  d: "M105.802.002l-.01.001-.05.002-.003.001c-.284.025-.543.13-.753.293-8.435 6.281-15.257 7.543-19.772 8.38-2.232.413-3.995.739-5.346 1.512l-.015.009a9.244 9.244 0 00-2.972 2.792c-4.897-5.398-12.315-7.88-22.093-7.381l-1.985.101c-9.777.501-16.904 3.724-21.226 9.594a9.227 9.227 0 00-3.24-2.476l-.014-.007c-1.422-.632-3.21-.776-5.471-.96-4.576-.372-11.493-.934-20.528-6.326a1.444 1.444 0 00-1.732.186A1.447 1.447 0 00.29 7.438c.263.517 1.305 2.868 1.6 3.522 1.271 2.855 5.737 8.747 6.938 15.981.123.698.29 1.505.5 2.318l4.237.409-3.195 2.69a17.632 17.632 0 005.315 7.389l4.768-2.727-1.594 4.521c2.23.848 5.21 1.097 8.472.511-.372 2.092-.441 3.758-.211 5.054.589 3.358 2.474 5.064 3.842 6.055 2.854 2.07 7.274 3.421 13.513 4.131a3.977 3.977 0 012.638 2.072c.616 1.579 3.621 2.218 9.404 2.009l.021-.001.233-.012.016-.002c3.346-.208 5.795-.631 7.278-1.255 1.25-.527 1.718-1.17 1.871-1.686a3.981 3.981 0 012.42-2.344c6.449-1.412 10.844-3.32 13.431-5.835 2.523-2.451 2.807-5 2.801-6.703 0-.045-.003-.09-.006-.135a31.616 31.616 0 00-.711-4.246c1.116.092 2.241.091 3.359-.009l-.799-4.297 3.167 3.675.182-2.544 1.984 1.926c2.457-1.219 4.474-3.108 5.786-5.421l-5.092-3.901 6.426 1.143a19.724 19.724 0 001.562-5.889l-2.902-1.26s3.156-.625 3.155-.641l-4.218-1.783 4.371-.181c.999-6.388 4.214-11.707 5.099-14.344.218-.648 1.03-3.053 1.248-3.608A1.447 1.447 0 00105.87 0l-.068.002",
  mask: "url(#grade-mascot_svg__h)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(80 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__k",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__j)",
  d: "M11.855 11.793c-5.546 2.647-9.914 5.223-10.762 9.269-.866 4.141.876 9.544 2.298 14.354.171.537.323 1.08.463 1.624 1.482.1 2.456.188 3.376.105l-.799-4.297 3.167 3.675.182-2.544 1.984 1.926c2.457-1.219 4.474-3.108 5.786-5.421l-5.092-3.901 6.426 1.143a19.724 19.724 0 001.562-5.889l-2.902-1.26s3.156-.625 3.155-.641l-4.218-1.783 4.371-.181c.999-6.388 4.214-11.707 5.099-14.344.218-.648 1.03-3.053 1.248-3.608-4.105 6.525-9.764 9.111-15.344 11.773",
  mask: "url(#grade-mascot_svg__k)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(56 9)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__l"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__m)",
  d: "M.612 1.165c-.76.575-.109 1.439 1.661 1.695a4.825 4.825 0 003.701-.895c.43-.44-.165-1.037-1.016-1.113 0 0-.816-.059-1.752-.059-1.027 0-2.199.071-2.594.372",
  mask: "url(#grade-mascot_svg__n)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53 13)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__q",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__o"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__p)",
  d: "M.468 1.921c-.208.767 1.682 1.298 2.873.997 1.191-.3 2.188-2.37.169-2.366h-.007C2.458.552.675 1.158.468 1.921",
  mask: "url(#grade-mascot_svg__q)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__r"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__s)",
  d: "M5.055.133C3.598.349.325 1.758.36 2.448c.035.69 2.385 1.777 4.879 1.29 2.494-.487 3.504-.892 3.307-1.709-.141-.606-1.77-1.923-3.16-1.923-.112 0-.223.009-.331.027",
  mask: "url(#grade-mascot_svg__t)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__w",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__u"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__v)",
  d: "M1.89 3.96c1.271 2.855 5.737 8.747 6.938 15.981.123.698.29 1.505.5 2.318l4.237.409-3.195 2.69a17.632 17.632 0 005.315 7.389l4.768-2.727-1.594 4.521c2.072.789 4.273 1.212 8.49.504.105-.554.222-1.094.343-1.599 1.089-4.62 2.607-10.947.773-14.667-1.011-2.052-2.15-5.032-8.86-7.127l-.115-.037c-1.216-.364-4.485-1.045-7.994-2.852C4.443 5.131.29.438.29.438c.263.517 1.305 2.868 1.6 3.522",
  mask: "url(#grade-mascot_svg__w)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34 38)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "grade-mascot_svg__z",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#grade-mascot_svg__x"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grade-mascot_svg__y)",
  d: "M34.06 4.356c-.507.022-1.046.027-1.624.013-4.568-.095-6.577-.65-11.515-.435-4.938.217-6.892.959-11.426 1.44-.581.083-1.12.107-1.62.128-4.219.186-5.827-1.01-6.12-3.286-3.327 2.98 1.291 6.854 4.77 8.411 3.48 1.558 7.887 2.245 14.109 2.154l1.359-.06c6.206-.471 10.536-1.523 13.873-3.379v-.013c3.267-1.813 7.584-6.091 3.997-8.782-.088 2.273-1.582 3.624-5.803 3.809",
  mask: "url(#grade-mascot_svg__z)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M37.975 46.156c-1.078-.83-2.74-2.32-2.542-3.86a.102.102 0 01.187-.043c.787 1.195 2.195 1.758 3.573 1.965.073.01.11.093.07.156l-1.141 1.757a.102.102 0 01-.147.025m2.623 1.608a14.784 14.784 0 01-1.747-.984.155.155 0 01-.044-.211l1.232-1.908a.102.102 0 01.185.036l.589 2.898c.033.164-.064.24-.215.169m1.08.004l-.622-3.068a.305.305 0 01.295-.366c.19-.004.378-.01.56-.017.502-.023 1.07-.047 1.685-.135l.134-.014a.305.305 0 01.285.475l-2.152 3.162a.102.102 0 01-.184-.037m5.354 1.798c-1.514-.216-2.883-.518-4.129-.91a.408.408 0 01-.216-.618c.645-.95 2.124-3.13 2.526-3.732a.102.102 0 01.177.016l2.071 4.676a.407.407 0 01-.429.568m1.444-.201L46.29 44.35a.407.407 0 01.31-.564c.563-.088 1.096-.178 1.622-.266a74.93 74.93 0 012.91-.448c.24-.03.418.216.315.435l-2.786 5.86a.102.102 0 01-.185-.002m5.414.608a56.545 56.545 0 01-3.902-.108.407.407 0 01-.344-.579l2.387-5.099a.101.101 0 01.186.006l2.05 5.223a.408.408 0 01-.377.557m1.455-.535a.101.101 0 01-.192.008l-2.367-6.03a.408.408 0 01.346-.554 48.938 48.938 0 013.65-.16c.273-.002.47.26.393.522l-1.83 6.214zm5.151-.033a55.767 55.767 0 01-3.879.448.407.407 0 01-.424-.52l1.586-5.383a.102.102 0 01.186-.023l2.822 4.872a.406.406 0 01-.29.606m1.277-.612l-3.287-5.596a.306.306 0 01.275-.46c1.038.042 1.976.116 2.939.192.572.045 1.153.091 1.768.132a.305.305 0 01.27.401l-1.78 5.312a.103.103 0 01-.185.02m5.673-1.214c-1.208.5-2.545.921-4.034 1.268a.407.407 0 01-.477-.529l1.655-4.839a.1.1 0 01.174-.03c.453.564 2.118 2.607 2.843 3.496a.407.407 0 01-.16.634m1.495-4.101l-.352 3.11a.102.102 0 01-.18.054l-2.42-2.962a.305.305 0 01.242-.5l.135.004c.62.033 1.188.009 1.689-.014.184-.007.37-.018.56-.031a.306.306 0 01.326.339m2.377 1.879a14.8 14.8 0 01-1.653 1.133c-.146.085-.248.017-.23-.15l.333-2.938a.102.102 0 01.182-.051l1.393 1.792a.152.152 0 01-.025.214m1.437-1.279c-.183.195-.38.39-.586.58a.102.102 0 01-.149-.014l-1.295-1.656a.102.102 0 01.056-.162c.894-.213 1.622-.52 2.198-.928a3.854 3.854 0 001.194-1.336c.044-.084.17-.065.188.03.036.167.046.34.034.522-.059.864-.626 1.89-1.64 2.964"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313866",
  d: "M33.587 26.322c3.326-.25 7.66 3.322 14.108 5.547 2.35.807 4.88 1.428 5.245 1.516.365.09-2.239.375-3.732.614a7.418 7.418 0 01-6.592 3.985c-4.434.192-6.684-2.47-7.333-5.307a8.2 8.2 0 01-.224-2.388s1.931-.355 6.13.41c-2.638-1.171-4.84-2.045-6.756-2.03a9.804 9.804 0 00-3.332.64s.47-2.854 2.486-2.987m41.939.586v.016c-1.901.157-4.043 1.213-6.546 2.607 4.108-1.126 6.07-.94 6.07-.94a8.428 8.428 0 01-.023 2.4c-.394 2.882-2.413 5.73-6.847 5.922a7.43 7.43 0 01-6.912-3.4c-1.508-.108-4.134-.167-3.771-.288.364-.12 2.815-.957 5.094-1.965 6.253-2.776 10.232-6.708 13.576-6.748 2.012-.027 2.705 2.763 2.705 2.763a9.773 9.773 0 00-3.346-.367"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M68.965 29.553c4.1-1.125 6.056-.939 6.056-.939a8.465 8.465 0 01-.024 2.4c-.39 2.884-2.405 5.731-6.829 5.924a7.408 7.408 0 01-6.895-3.403c2.695-1.026 5.403-2.535 7.692-3.982M49.22 34.021a7.409 7.409 0 01-6.575 3.986c-4.423.192-6.676-2.471-7.317-5.31a8.547 8.547 0 01-.231-2.39s1.935-.354 6.114.412c2.406 1.244 5.235 2.513 8.009 3.302"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7DC9A9",
  d: "M46.603 35.056c.168-1.266-6.761-2.665-6.761-2.665-2.213-.706-2.003.688-1.577 1.372.427.684 1.795 3.131 3.914 3.34 2.087.207 4.309-1.178 4.424-2.047m25.792-2.735c-.333.733-1.551 3.126-3.61 3.666-2.06.54-4.283-.416-4.584-1.656-.302-1.24 6.504-3.24 6.504-3.24.936-.322 2.528-.62 1.69 1.23"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M43.958 33.566s2.252.454 2.345 1.453c.093.999-3.317-1.01-4.174-1.323-.857-.315-.079-.698 1.83-.13m22.704-.947s-2.203.646-2.209 1.65c-.006 1.003 3.217-1.293 4.043-1.679.826-.388.02-.703-1.834.03"
})));

function SvgGradeMascot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 79
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/grade-mascot.4149391c.svg";
export { SvgGradeMascot as ReactComponent };